<template>
  <el-card class="week-star-new">
    <h1 class="week-star-new__title">周星活动配置(新)</h1>
    <el-tabs v-model="activeName">
      <el-tab-pane label="周星礼物配置" name="first">
        <WeekGiftConfig v-if="activeName === 'first'" />
      </el-tab-pane>
      <el-tab-pane label="周星奖品配置" name="second">
        <WeekRewardConfig  v-if="activeName === 'second'" />
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>
<script>
import WeekGiftConfig from '@/components/WeekStarNew/WeekGiftConfig';
import WeekRewardConfig from '@/components/WeekStarNew/WeekRewardConfig';
export default {
  components: {
    WeekGiftConfig,
    WeekRewardConfig
  },
  data() {
    return {
      activeName: 'first'
    }
  },

}
</script>

<style scoped lang="scss">
.week-star-new {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }
}
</style>